<!-- eslint-disable prettier/prettier -->
<template>
  <div class="home1 container">
    <!--    <div class="one">-->
    <!--      <div class="title">-->
    <!--        <div>Product Display</div>-->
    <!--        <div><span>产品</span><span>展示</span></div>-->
    <!--      </div>-->
    <!--      <div class="container prodect">-->
    <!--        <div class="left">-->
    <!--          <div>上海天爵制品</div>-->
    <!--          <div>专注木托盘、储丝箱/贮丝箱等加工的生产基地</div>-->
    <!--          <div :class="['item', { active: active === 1 }]" @click="active = 1">-->
    <!--            高端木托盘-->
    <!--          </div>-->
    <!--          <div :class="['item', { active: active === 2 }]" @click="active = 2">-->
    <!--            储丝箱/贮丝箱-->
    <!--          </div>-->
    <!--          &lt;!&ndash;          <div :class="['item', { active: active === 3 }]" @click="active = 3">&ndash;&gt;-->
    <!--          &lt;!&ndash;            进口原木&ndash;&gt;-->
    <!--          &lt;!&ndash;          </div>&ndash;&gt;-->
    <!--          &lt;!&ndash;          <div :class="['item', { active: active === 4 }]" @click="active = 4">&ndash;&gt;-->
    <!--          &lt;!&ndash;            进口集成材&ndash;&gt;-->
    <!--          &lt;!&ndash;          </div>&ndash;&gt;-->
    <!--          &lt;!&ndash;          <div :class="['item', { active: active === 5 }]" @click="active = 5">&ndash;&gt;-->
    <!--          &lt;!&ndash;            集成材加工&ndash;&gt;-->
    <!--          &lt;!&ndash;          </div>&ndash;&gt;-->
    <!--        </div>-->
    <!--        <div class="right">-->
    <!--          <template v-if="active === 1">-->
    <!--            <div v-for="i in 6" :key="i">-->
    <!--              <img v-if="i === 1" alt="" src="@/assets/imgs/1.jpg" />-->
    <!--              <img v-if="i === 2" alt="" src="@/assets/imgs/2.jpg" />-->
    <!--              <img v-if="i === 3" alt="" src="@/assets/imgs/5.jpg" />-->
    <!--              <img v-if="i === 4" alt="" src="@/assets/imgs/3.jpg" />-->
    <!--              <img v-if="i === 5" alt="" src="@/assets/imgs/6.jpg" />-->
    <!--              <img v-if="i === 6" alt="" src="@/assets/imgs/7.jpg" />-->
    <!--              <img alt="" src="@/assets/imgs/productBj.png" />-->
    <!--              <div>高端木托盘</div>-->
    <!--              <div>厂家供应 实木托盘</div>-->
    <!--            </div>-->
    <!--          </template>-->

    <!--          <template v-if="active === 2">-->
    <!--            <div v-for="i in 6" :key="i">-->
    <!--              <img v-if="i === 1" alt="" src="@/assets/imgs/11.jpg" />-->
    <!--              <img v-if="i === 2" alt="" src="@/assets/imgs/12.jpg" />-->
    <!--              <img v-if="i === 3" alt="" src="@/assets/imgs/15.jpg" />-->
    <!--              <img v-if="i === 4" alt="" src="@/assets/imgs/13.jpg" />-->
    <!--              <img v-if="i === 5" alt="" src="@/assets/imgs/16.jpg" />-->
    <!--              <img v-if="i === 6" alt="" src="@/assets/imgs/17.jpg" />-->
    <!--              <img alt="" src="@/assets/imgs/productBj.png" />-->
    <!--              <div>储丝箱/贮丝箱</div>-->
    <!--              <div>厂家供应 储丝箱/贮丝箱</div>-->
    <!--            </div>-->
    <!--          </template>-->

    <!--          &lt;!&ndash;          <template v-if="active === 3">&ndash;&gt;-->
    <!--          &lt;!&ndash;            <div v-for="i in 6" :key="i">&ndash;&gt;-->
    <!--          &lt;!&ndash;              <img v-if="i === 1" alt="" src="@/assets/imgs/1.jpg" />&ndash;&gt;-->
    <!--          &lt;!&ndash;              <img v-if="i === 2" alt="" src="@/assets/imgs/2.jpg" />&ndash;&gt;-->
    <!--          &lt;!&ndash;              <img v-if="i === 3" alt="" src="@/assets/imgs/5.jpg" />&ndash;&gt;-->
    <!--          &lt;!&ndash;              <img v-if="i === 4" alt="" src="@/assets/imgs/3.jpg" />&ndash;&gt;-->
    <!--          &lt;!&ndash;              <img v-if="i === 5" alt="" src="@/assets/imgs/6.jpg" />&ndash;&gt;-->
    <!--          &lt;!&ndash;              <img v-if="i === 6" alt="" src="@/assets/imgs/7.jpg" />&ndash;&gt;-->
    <!--          &lt;!&ndash;              <img alt="" src="@/assets/imgs/productBj.png" />&ndash;&gt;-->
    <!--          &lt;!&ndash;              <div>进口原木</div>&ndash;&gt;-->
    <!--          &lt;!&ndash;              <div>厂家供应 实木托盘</div>&ndash;&gt;-->
    <!--          &lt;!&ndash;            </div>&ndash;&gt;-->
    <!--          &lt;!&ndash;          </template>&ndash;&gt;-->

    <!--          &lt;!&ndash;          <template v-if="active === 4">&ndash;&gt;-->
    <!--          &lt;!&ndash;            <div v-for="i in 6" :key="i">&ndash;&gt;-->
    <!--          &lt;!&ndash;              <img v-if="i === 1" alt="" src="@/assets/imgs/1.jpg" />&ndash;&gt;-->
    <!--          &lt;!&ndash;              <img v-if="i === 2" alt="" src="@/assets/imgs/2.jpg" />&ndash;&gt;-->
    <!--          &lt;!&ndash;              <img v-if="i === 3" alt="" src="@/assets/imgs/5.jpg" />&ndash;&gt;-->
    <!--          &lt;!&ndash;              <img v-if="i === 4" alt="" src="@/assets/imgs/3.jpg" />&ndash;&gt;-->
    <!--          &lt;!&ndash;              <img v-if="i === 5" alt="" src="@/assets/imgs/6.jpg" />&ndash;&gt;-->
    <!--          &lt;!&ndash;              <img v-if="i === 6" alt="" src="@/assets/imgs/7.jpg" />&ndash;&gt;-->
    <!--          &lt;!&ndash;              <img alt="" src="@/assets/imgs/productBj.png" />&ndash;&gt;-->
    <!--          &lt;!&ndash;              <div>进口集成材</div>&ndash;&gt;-->
    <!--          &lt;!&ndash;              <div>厂家供应 实木托盘</div>&ndash;&gt;-->
    <!--          &lt;!&ndash;            </div>&ndash;&gt;-->
    <!--          &lt;!&ndash;          </template>&ndash;&gt;-->

    <!--          &lt;!&ndash;          <template v-if="active === 5">&ndash;&gt;-->
    <!--          &lt;!&ndash;            <div v-for="i in 6" :key="i">&ndash;&gt;-->
    <!--          &lt;!&ndash;              <img v-if="i === 1" alt="" src="@/assets/imgs/1.jpg" />&ndash;&gt;-->
    <!--          &lt;!&ndash;              <img v-if="i === 2" alt="" src="@/assets/imgs/2.jpg" />&ndash;&gt;-->
    <!--          &lt;!&ndash;              <img v-if="i === 3" alt="" src="@/assets/imgs/5.jpg" />&ndash;&gt;-->
    <!--          &lt;!&ndash;              <img v-if="i === 4" alt="" src="@/assets/imgs/3.jpg" />&ndash;&gt;-->
    <!--          &lt;!&ndash;              <img v-if="i === 5" alt="" src="@/assets/imgs/6.jpg" />&ndash;&gt;-->
    <!--          &lt;!&ndash;              <img v-if="i === 6" alt="" src="@/assets/imgs/7.jpg" />&ndash;&gt;-->
    <!--          &lt;!&ndash;              <img alt="" src="@/assets/imgs/productBj.png" />&ndash;&gt;-->
    <!--          &lt;!&ndash;              <div>集成材加工</div>&ndash;&gt;-->
    <!--          &lt;!&ndash;              <div>厂家供应 实木托盘</div>&ndash;&gt;-->
    <!--          &lt;!&ndash;            </div>&ndash;&gt;-->
    <!--          &lt;!&ndash;          </template>&ndash;&gt;-->
    <!--        </div>-->
    <!--      </div>-->
    <!--    </div>-->
    <div class="one">
      <div class="title">
        <div>Application Area</div>
        <div><span>应用</span><span>领域</span></div>
      </div>
      <div class="area">
        <div>
          <img v-if="num === 1" alt="" src="@/assets/imgs/y1.png" />
          <img v-if="num === 2" alt="" src="@/assets/imgs/y5.jpg" />
          <img v-if="num === 3" alt="" src="@/assets/imgs/y3.jpg" />
          <img v-if="num === 4" alt="" src="@/assets/imgs/y4.png" />
        </div>
        <div>
          <div :class="{ active: num === 1 }">烟草行业 <span></span></div>
          <div :class="{ active: num === 2 }">医药行业<span></span></div>
          <div :class="{ active: num === 3 }">酒业<span></span></div>
          <div :class="{ active: num === 4 }">更多<span></span></div>
        </div>
      </div>
    </div>
    <div class="one">
      <div class="title">
        <div>Four Advantages</div>
        <div><span>四大</span><span>优势</span></div>
      </div>
      <div class="head">
        <div :class="{ active: num1 === 1 }">
          <div>
            <img v-if="num1 !== 1" alt="" src="@/assets/imgs/jy.png" />
            <img v-else alt="" src="@/assets/imgs/jy1.png" />
          </div>
          <div>
            <div>经验丰富</div>
            <div>Rich experience</div>
          </div>
          <span></span>
        </div>
        <div :class="{ active: num1 === 2 }">
          <div>
            <img v-if="num1 !== 2" alt="" src="@/assets/imgs/zy.png" />
            <img v-else alt="" src="@/assets/imgs/zy1.png" />
          </div>
          <div>
            <div>专业团队</div>
            <div>Professional team</div>
          </div>
          <span></span>
        </div>
        <div :class="{ active: num1 === 3 }">
          <div>
            <img v-if="num1 !== 3" alt="" src="@/assets/imgs/pz.png" />
            <img
              v-else
              alt=""
              src="@/assets/imgs/pz1.png"
              style="position: relative; top: 3px"
            />
          </div>
          <div>
            <div>品质保障</div>
            <div>Quality guarantee</div>
          </div>
          <span></span>
        </div>
        <div :class="{ active: num1 === 4 }">
          <div>
            <img v-if="num1 !== 4" alt="" src="@/assets/imgs/sh.png" />
            <img v-else alt="" src="@/assets/imgs/sh1.png" />
          </div>
          <div>
            <div>售后保障</div>
            <div>After-sale protection</div>
          </div>
          <span></span>
        </div>
      </div>

      <div v-if="num1 === 1" class="fourContent">
        <div>
          <div>
            <div>01</div>
            <div>
              <div>多年托盘、储丝箱等生产经验</div>
              <div>为广大客户提供优良的木业产品</div>
            </div>
          </div>
          <div>
            <div>
              <span></span>
              我司是一家集木材干燥加工、木托盘、储丝箱/贮丝箱、木制品、家具精加工的生产基地，种类齐全，质量可靠。
            </div>
            <div>
              <span></span>
              我司凭借在木制品制造业三十余年的深耕细作，具有深厚的技术积累和丰富的行业经验。
            </div>
          </div>
        </div>
        <div>
          <img alt="" src="@/assets/imgs/j1.jpg" />
        </div>
      </div>

      <div v-if="num1 === 2" class="fourContent">
        <div>
          <div>
            <div>02</div>
            <div>
              <div>熟练的生产技术团队</div>
              <div>熟练的生产人员为产品质量提供了保障</div>
            </div>
          </div>
          <div>
            <div>
              <span></span>
              多年来我们积累了一批熟练的生产制造人员，我们始终把团队合作当作重点，锻造了一支熟练的生产团队
            </div>
            <div>
              <span></span>
              我厂不断激励员工对托盘、储丝箱/贮丝箱等进行创新，生产更高质量产品
            </div>
          </div>
        </div>
        <div>
          <img alt="" src="@/assets/imgs/j2.jpg" />
        </div>
      </div>

      <div v-if="num1 === 3" class="fourContent">
        <div>
          <div>
            <div>03</div>
            <div>
              <div>产品质量符合国家工业标准</div>
              <div>具有坚固持久、不易变形、承载力大等特点</div>
            </div>
          </div>
          <div>
            <div>
              <span></span>
              在秉承了昆明天爵经济发展有限公司做木托盘的经验，及大量跟踪、研究国内外同类产品的基础上，不断改进、完善质量管理。
            </div>
            <div>
              <span></span>
              产品质量符合国家GB/T 4996-2014、GB/T 4995-2014、GB/T
              2934-2007、YC/T 215-2007等工业标准要求。
            </div>
          </div>
        </div>
        <div>
          <img alt="" src="@/assets/imgs/j3.jpg" />
        </div>
      </div>

      <div v-if="num1 === 4" class="fourContent">
        <div>
          <div>
            <div>04</div>
            <div>
              <div>完善的售后服务</div>
              <div>一对一针对服务，客户满意</div>
            </div>
          </div>
          <div>
            <div>
              <span></span>
              技术服务团队，全程为您跟进订单生产进展，快速响应，交货物流速度方面全面保障
            </div>
            <div>
              <span></span>
              完善的售后服务体系与保障措施为广大的客户提供优质高效的服务
            </div>
          </div>
        </div>
        <div>
          <img alt="" src="@/assets/imgs/j4.jpg" />
        </div>
      </div>
    </div>
    <div class="one">
      <div class="title">
        <div>Main Business</div>
        <div><span>企业</span><span>介绍</span></div>
      </div>
      <div class="about">
        <div>
          <img alt="" src="@/assets/imgs/gc.png" />
        </div>
        <div>
          上海天爵木业有限公司成立于2003年1月，注册资金人民币1000万元。本公司是中国物流与采购联合会委员、及美国国家木托盘协会会员(NWPCA)。并于2010年1月通过ISO19001-2008质量管理体系认证，公司在成立的短短几年时间内，本着“竞争、服务、卓越”的企业精神，凭借一流的设备、丰富的生产管理经验、高素质的员工队伍，良好的信誉和服务，出色的产品质量，在激烈的市场竞争中不断发展，赢得了国内外客户的赞誉和首肯。在这十余年的时间，公司始终坚持“创新、品质、服务、敬业”的服务理念，生产规模逐渐壮大，在实力、产品、制度、文化上都得到了更高的提升。
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HomeView",
  components: {},
  data() {
    return {
      num: 1,
      num1: 1,
      time: "",
      time1: "",
      active: 1,
    };
  },
  mounted() {
    this.time = setInterval(() => {
      this.num++;
      if (this.num > 4) {
        this.num = 1;
      }
    }, 3000);
    this.time1 = setInterval(() => {
      this.num1++;
      this.active = this.active === 1 ? 2 : 1;
      if (this.num1 > 4) {
        this.num1 = 1;
      }
    }, 4000);
  },
  unmounted() {
    clearInterval(this.time);
    clearInterval(this.time1);
  },
};
</script>
<style lang="less">
.one {
  padding-top: 70px;

  .title {
    position: relative;

    > div:nth-child(2) {
      font-weight: bold;
      font-size: 40px;
      color: #333333;

      span:nth-child(2) {
        color: #2b3a86;
      }
    }

    > div:nth-child(1) {
      font-weight: normal;
      font-size: 69px;
      color: rgba(230, 154, 21, 0.3);
      position: absolute;
      left: 50%;
      top: 35%;
      transform: translateX(-50%);
    }
  }

  .prodect {
    display: flex;
    justify-content: space-between;
    height: 650px;
    margin-top: 57px;

    > div:first-child {
      width: 238px;
    }

    > div:nth-child(2) {
      width: 870px;
    }

    .left {
      text-align: left;

      > div:first-child {
        font-weight: bold;
        font-size: 36px;
        color: #2b3a86;
      }

      > div:nth-child(2) {
        font-weight: 400;
        font-size: 14px;
        color: #888888;
        margin-top: 14px;
        margin-bottom: 20px;
      }

      .item {
        width: 200px;
        height: 40px;
        background: #efefef;
        margin-top: 16px;
        font-weight: 400;
        font-size: 14px;
        color: #666666;
        padding-left: 30px;
        line-height: 40px;
      }

      .active {
        background: #2b3a86;
        color: #fff;
      }
    }

    .right {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;

      > div {
        width: 270px;
        height: 310px;
        border: 1px solid #ededed;
        position: relative;

        > img:first-child {
          width: 100%;
          height: 270px;
        }

        > img:nth-child(2) {
          width: 100%;
          height: 270px;
          position: absolute;
          left: 0;
          top: 0;
        }

        > div:nth-child(3) {
          position: absolute;
          left: 0;
          bottom: 45px;
          width: 70%;
          text-align: center;
          color: #fff;
        }

        > div:nth-child(4) {
          margin-top: 5px;
        }
      }
    }
  }

  .area {
    display: flex;
    justify-content: center;
    height: 560px;
    margin-top: 50px;

    > div:first-child {
      width: 940px;

      > img {
        width: 100%;
        height: 100%;
      }
    }

    > div:nth-child(2) {
      width: 260px;

      > div {
        width: 100%;
        height: 140px;
        background: #2b3a86;
        color: #fff;
        font-size: 30px;
        line-height: 140px;

        > span {
          display: none;
        }
      }

      .active {
        background: #e69a15;
        position: relative;

        > span {
          position: absolute;
          display: inline-block;
          width: 20px;
          height: 20px;
          background: #e69a15;
          left: -10px;
          top: calc(50% - 10px);
          transform: rotate(45deg);
        }
      }
    }
  }

  .head {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    margin-top: 70px;
    padding: 0;

    > div {
      flex: 1;
      height: 140px;
      background: #2b3a86;
      color: #fff;
      font-size: 30px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      padding-left: 42px;

      > div:first-child {
        width: 84px;
        height: 84px;
        background-color: #fff;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-right: 14px;

        img {
          width: 60px;
          height: 60px;
        }
      }

      > div:nth-child(2) {
        > div:first-child {
          font-weight: bold;
          font-size: 30px;
          color: #ffffff;
        }

        > div:nth-child(2) {
          font-weight: 400;
          font-size: 16px;
          color: #ffffff;
        }
      }

      > span {
        display: none;
      }
    }

    .active {
      background: #e69a15;
      position: relative;

      > span {
        position: absolute;
        display: inline-block;
        width: 20px;
        height: 20px;
        background: #e69a15;
        bottom: -10px;
        left: calc(50% - 10px);

        transform: rotate(45deg);
      }
    }
  }

  .about {
    height: 420px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 70px 0;

    > div {
      flex: 1;
      height: 100%;

      img {
        width: 100%;
        height: 100%;
      }
    }

    > div:nth-child(2) {
      background-color: #e69a15;
      font-weight: 400;
      font-size: 16px;
      color: #ffffff;
      padding: 116px 48px;
      box-sizing: border-box;
      line-height: 25px;
      text-align: left;
    }
  }

  .fourContent {
    height: 420px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 30px;

    > div {
      flex: 1;
      height: 100%;

      img {
        width: 100%;
        height: 100%;
      }
    }

    > div:first-child {
      padding: 78px 52px 0;
      box-sizing: border-box;
      background-color: #f2f2f2;

      > div:first-child {
        border-bottom: 1px solid #dbdbdb;
        text-align: left;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        // border: 1px solid red;
        > div:first-child {
          color: #2b3a86;
          width: 73px;
          font-weight: bold;
          font-size: 72px;
        }

        > div:nth-child(2) {
          margin-left: 21px;

          > div:first-child {
            font-weight: bold;
            font-size: 30px;
            color: #2b3a86;
          }

          > div:nth-child(2) {
            font-weight: 400;
            font-size: 18px;
            color: #333333;
          }
        }
      }

      > div:nth-child(2) {
        margin-top: 57px;

        > div {
          text-align: left;
          font-weight: 400;
          font-size: 16px;
          color: #666666;
          line-height: 35px;

          span {
            display: inline-block;
            width: 20px;
            height: 20px;
            background-color: #666;
            border-radius: 50%;
            position: relative;
            top: 4px;
          }
        }
      }
    }
  }
}
</style>
